/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';

const StudentsList = ({
  students,
  groupKey,
  addStudent,
  removeStudent,
  isSelectedStudent,
}) => {
  function renderStudent(student, index) {
    return (
      <Student
        groupKey={groupKey}
        thisKey={index}
        key={index}
        student={student}
        check={() => addStudent(student)}
        unCheck={() => removeStudent(student)}
        isSelected={() => isSelectedStudent(student)}
      />
    );
  }

  return (
    <List component="div" disablePadding>
      {students.map((student, index) => renderStudent(student, index))}
    </List>
  );
};

const Student = ({
  student,
  thisKey,
  groupKey,
  check,
  unCheck,
  isSelected,
}) => {
  const [isChecked, setIsChecked] = useState(false);

  function handleChange() {
    if (isSelected()) {
      unCheck();
    } else {
      check();
    }
    // This is to trigger a rerender
    setIsChecked(!isChecked);
  }

  return (
    <ListItem
      key={`${groupKey}_${thisKey}`}
      button
      style={{ marginLeft: '2%' }}
    >
      <ListItemIcon>
        <Checkbox
          edge="start"
          checked={isSelected()}
          disableRipple
          onChange={() => handleChange()}
        />
      </ListItemIcon>
      <ListItemText primary={student.name} />
    </ListItem>
  );
};

StudentsList.propTypes = {
  students: PropTypes.array.isRequired,
  groupKey: PropTypes.number.isRequired,
  addStudent: PropTypes.func.isRequired,
  removeStudent: PropTypes.func.isRequired,
  isSelectedStudent: PropTypes.func.isRequired,
};

export default StudentsList;
